import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import useCourse from '@/composables/useCourse'
  import useIcons from '@/composables/useIcons'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useBreakpoint from '@/composables/useBreakpoint'
  import BookmarkLesson from '@/components/course/BookmarkLesson.vue'
  import { useRoute } from 'vue-router/composables'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseBreadcrumbs',
  props: {
    isSearching: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

const props = __props;

  

  const { translateString } = useI18n()
  const route = useRoute()
  const { currentLessonTitle, lessonId, moduleId, currentModuleTitle, currentMobileModuleTitle, currentLesson } =
    useCourse()
  const { arrowRightIndicator } = useIcons()
  const { isMobileDevice } = useBreakpoint()

  const isStartPage = computed(() => route.name === 'CourseModuleStartPage')

  const allCrumbs = computed(() => {
    const crumbs: { url: string; title: string }[] = [
      {
        url: '/trainings',
        title: translateString('trainings.title'),
      },
      {
        url: `/courses/${route.params.courseId}/info`,
        title: translateString('courses.trainingDetails'),
      },
    ]
    if (props.isSearching) {
      crumbs.push({
        url: '',
        title: translateString('search.searchResults'),
      })
      return crumbs
    }
    if (moduleId.value && ((isMobileDevice.value && currentMobileModuleTitle.value) || currentModuleTitle.value)) {
      crumbs.push({
        url: `/courses/${route.params.courseId}/module/${moduleId.value}`,
        title: isMobileDevice.value ? currentMobileModuleTitle.value : currentModuleTitle.value,
      })
    }
    if (lessonId.value && currentLessonTitle.value) {
      crumbs.push({
        url: '',
        title: currentLessonTitle.value,
      })
    }
    if (isStartPage.value) {
      crumbs.push({
        url: '',
        title: translateString('courses.startPage'),
      })
    }
    if (route.name === 'DownloadMaterials') {
      crumbs.push({
        url: '',
        title: translateString('downloads'),
      })
    }
    if (route.name === 'ExamStartPage') {
      crumbs.push({
        url: '',
        title: translateString('courses.examSimulation.title'),
      })
    }
    if (route.name === 'GuidedQuiz') {
      crumbs.push({
        url: '',
        title: translateString('courses.guidedQuizCrumb'),
      })
    }
    return crumbs
  })

  const mobileCrumbs = computed(() => {
    if (isMobileDevice.value) {
      const crumbs = allCrumbs.value.slice(0, -1)
      if (crumbs.length) return crumbs.slice(-1)
    }
    return []
  })

return { __sfc: true,props, translateString, route, currentLessonTitle, lessonId, moduleId, currentModuleTitle, currentMobileModuleTitle, currentLesson, arrowRightIndicator, isMobileDevice, isStartPage, allCrumbs, mobileCrumbs, computed, useCourse, useIcons, SVGRenderer, useBreakpoint, BookmarkLesson, useRoute, useI18n }
}

})